import React, {
  lazy,
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import {
  Link,
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import ComponentLoader from "../../../../Shared/Sidebar/ComponentLoader";
import {
  addEmployeeExperience,
  getEmployeeExpriences,
} from "../Service/profileService";
import * as Yup from "yup";
import { useFormik } from "formik";
import { TostMsg } from "../../../../App";
import { InputSwitch } from "primereact/inputswitch";
import ERROR_LIST from "../../../../Services/Global-Services/Hadle_Errors";
import { Editor } from "primereact/editor";

function AddExperience() {
  const { GUID } = useParams();
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  let history = useHistory();
  const [expriencesData, setExpriencesList] = useState();
  const [checkedWorking, setCheckedWorking] = useState(false);
  const [Isloading, setIsloading] = useState(false);
  const toster = useContext(TostMsg);
  const [dateError, setDateError] = useState(false);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const [showContent, setSeleteContent] = useState([]);

  useEffect(() => {
    setIsloading(true);
    if (GUID?.length >= 0) {
      setTimeout(() => {
        setIsloading(false);
        getEmployeeExpriencesList();
        GetMasterSystemAlertList("edit_experience", 1);
      }, 1000);
    } else {
      setIsloading(false);
      GetMasterSystemAlertList("add_experience", 1);
      experienceForm.resetForm();
      setCheckedWorking(false);
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [GUID]);

  async function getEmployeeExpriencesList() {
    setIsloading(true);
    const params = {
      OrgId: userDetails.OrgId,
      ExperienceId: GUID ? Number(GUID) : 0,
      EmpId: userDetails?.EmpId,
    };
    try {
      const response = await getEmployeeExpriences(params);
      let editExperienceDetails = response?.Data;
      setExpriencesList(editExperienceDetails);
      if (editExperienceDetails[0].id) {
        const editExperienceData = {
          id: editExperienceDetails[0]?.id,
          designation: editExperienceDetails[0]?.Designation,
          company: editExperienceDetails[0]?.Company,
          location: editExperienceDetails[0]?.Location,
          startDate: editExperienceDetails[0]?.StartDate
            ? new Date(editExperienceDetails[0]?.StartDate)
                .toISOString()
                .split("T")[0]
            : null,
          endDate:
            editExperienceDetails[0]?.EndDate &&
            editExperienceDetails[0]?.EndDate !== "Till Now"
              ? new Date(editExperienceDetails[0]?.EndDate)
                  .toISOString()
                  .split("T")[0]
              : null,
          projectDetails: editExperienceDetails[0]?.ProjectDetails,
          responsibilities: editExperienceDetails[0]?.Responsibilities,
          technology: editExperienceDetails[0]?.Technology,
          currentlyWorkingHere: editExperienceDetails[0]?.CurrentlyWorkingHere,
        };

        setCheckedWorking(editExperienceDetails[0]?.CurrentlyWorkingHere);
        experienceForm.setValues(editExperienceData);
        setIsloading(false);
      }
    } catch (error) {
      setIsloading(false);
      toster.current.error(ERROR_LIST.DefaultError);
    }
  }

  const ExperienceValidation = Yup.object().shape({
    designation: Yup.string().required("Designation is required."),
    company: Yup.string().required("Company name is required."),
    location: Yup.string().required("Location is required."),
    currentlyWorkingHere: Yup.boolean().default(false),
    startDate: Yup.date()
      .transform((value, originalValue) =>
        originalValue === "" ? null : new Date(originalValue)
      )
      .required("Start date is required.")
      .typeError("Invalid start date"),

    endDate: Yup.date()
      .transform((value, originalValue) =>
        originalValue === "" ? null : new Date(originalValue)
      )
      .nullable()
      .when("currentlyWorkingHere", {
        is: false,
        then: Yup.date()
          .required("End date is required.")
          .min(
            Yup.ref("startDate"),
            "End Date must be greater than or equal to Start Date"
          ),
        otherwise: Yup.date().nullable(),
      })
      .typeError("Invalid end date"),
    projectDetails: "",
    responsibilities: Yup.string(),
    technology: "",
  });

  const experienceForm = useFormik({
    initialValues: {
      designation: "",
      company: "",
      location: "",
      currentlyWorkingHere: false,
      startDate: "",
      endDate: "",
      projectDetails: "",
      responsibilities: "",
      technology: "",
    },
    validationSchema: ExperienceValidation,
    onSubmit: async (data) => {
      setIsloading(true);
      let endDateValue = null;

      if (!data.currentlyWorkingHere) {
        if (!data.endDate) {
          setDateError(true);
          setIsloading(false);
          return;
        }
        endDateValue = new Date(data.endDate).toISOString().split("T")[0];
      }
      if (endDateValue && data.startDate > endDateValue) {
        setDateError(true);
        setIsloading(false);
        return;
      }
      const body = {
        OrgId: userDetails.OrgId,
        EmpId: userDetails.EmpId,
        Id: data?.id ?? 0,
        Designation: data.designation,
        Company: data.company,
        Location: data.location,
        CurrentlyWorkingHere: data.currentlyWorkingHere,
        StartDate: new Date(data.startDate).toISOString(),
        EndDate: endDateValue,
        ProjectDetails: data.projectDetails,
        Responsibilities: data.responsibilities,
        Technology: data.technology,
        ModifiedBy: userDetails?.EmpId,
      };
      try {
        setIsloading(false);
        setDateError(false);
        await addEmployeeExperience(body);
        if (data?.id) {
          GetMasterSystemAlertList("Experience_Updated", 0);
        } else {
          GetMasterSystemAlertList("Experience__Added", 0);
        }
        history.push(`/Profile/${userDetails.GUID}`);
      } catch (error) {
        console.error(error);
      } finally {
        setIsloading(false);
      }
    },
  });

  useEffect(() => {
    if (
      experienceForm.submitCount > 0 &&
      Object.keys(experienceForm.errors).length > 0
    ) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [experienceForm.errors, experienceForm.submitCount]);

  useEffect(() => {
    if (experienceForm.values.currentlyWorkingHere) {
      experienceForm.setFieldValue("endDate", "");
      experienceForm.setFieldTouched("endDate", false);
      experienceForm.setFieldError("endDate", undefined);
    }
  }, [experienceForm.values.currentlyWorkingHere]);

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setSeleteContent(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setSeleteContent(msg?.Desc);
      }
    });
  }, []);

  const setStartDate = (event) => {
    experienceForm.setFieldValue("endDate", event);
    if (event == experienceForm.values.endDate) {
      setDateError(false);
    }
  };

  const setEndDate = (event) => {
    const startDate = new Date(experienceForm.values.startDate);
    const endDate = new Date(event);
    const normalizeDate = (date) => {
      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    };
    const normalizedStartDate = normalizeDate(startDate);
    const normalizedEndDate = normalizeDate(endDate);
    if (normalizedStartDate <= normalizedEndDate) {
      setDateError(false);
    } else {
      setDateError(true);
    }
  };

  const headerTemplate = (
    <span className="ql-formats">
      <select className="ql-size">
        <option value="small"></option>
        <option selected></option>
        <option value="large"></option>
        <option value="huge"></option>
      </select>
      <select className="ql-font">
        <option selected></option>
        <option value="serif"></option>
        <option value="monospace"></option>
      </select>
      <button className="ql-bold"></button>
      <button className="ql-italic"></button>
      <button className="ql-underline"></button>
      <select className="ql-color"></select>
      <select className="ql-background"></select>
      <button className="ql-list" value="ordered"></button>
      <button className="ql-list" value="bullet"></button>
      <select className="ql-align"></select>
      <button className="ql-link"></button>
      <button className="ql-code-block"></button>
      <button className="ql-clean"></button>
    </span>
  );

  return (
    <>
      <div className="container-fluid  position-relation">
        <div className="row">
          <div className="col-xl-12">
            <div className="form-head d-flex flex-wrap align-items-center mb-4">
              <div className="me-auto">
                <h2 className="font-w600 mb-0">
                  {" "}
                  {GUID ? "Edit" : "Add"} Experience
                </h2>
                <p className="text-center">{showContent}</p>
              </div>
              <div className="rightside-tabs">
                <Link to={`/Profile/${userDetails.GUID}`}>
                  <button className="back-newticket w-auto float-right">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-arrow-left-short"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
                      />
                    </svg>{" "}
                    Back
                  </button>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-md-12">
            <form onSubmit={experienceForm.handleSubmit}>
              <div className="row mt-3 justify-content-center">
                <div className="col-xl-9">
                  <div className="row gx-3 gy-1">
                    <div className="mb-2 col-md-6">
                      <div className="cover-form">
                        <label className="form-label">
                          Designation<i className="inValidError">*</i>
                        </label>
                        <input
                          type="text"
                          cols="1"
                          rows="4"
                          name="designation"
                          className={
                            "form-control" +
                            (experienceForm.errors.designation &&
                            experienceForm.touched.designation
                              ? " is-invalid"
                              : "")
                          }
                          onChange={experienceForm.handleChange}
                          value={experienceForm.values.designation}
                          placeholder="Job title goes here..."
                        />
                      </div>
                      <div className="invalid-feedback">
                        {experienceForm.errors.designation &&
                        experienceForm.touched.designation
                          ? experienceForm.errors.designation
                          : null}
                      </div>
                    </div>

                    <div className="mb-2 col-md-6">
                      <div className="cover-form">
                        <label className="form-label">
                          Company name
                          <i className="inValidError">*</i>
                        </label>
                        <input
                          type="text"
                          name="company"
                          className={
                            "form-control" +
                            (experienceForm.errors.company &&
                            experienceForm.touched.company
                              ? " is-invalid"
                              : "")
                          }
                          onChange={experienceForm.handleChange}
                          value={experienceForm.values.company}
                          placeholder="Company Name"
                        />
                      </div>
                      <div className="invalid-feedback">
                        {experienceForm.errors.company &&
                        experienceForm.touched.company
                          ? experienceForm.errors.company
                          : null}
                      </div>
                    </div>

                    <div className="mb-2 col-md-12">
                      <div className="cover-form">
                        <label className="form-label">
                          Location
                          <i className="inValidError">*</i>
                        </label>
                        <input
                          type="text"
                          name="location"
                          className={
                            "form-control" +
                            (experienceForm.errors.location &&
                            experienceForm.touched.location
                              ? " is-invalid"
                              : "")
                          }
                          onChange={experienceForm.handleChange}
                          value={experienceForm.values.location}
                          placeholder="Location"
                        />
                      </div>
                      <div className="invalid-feedback">
                        {experienceForm.errors.location &&
                        experienceForm.touched.location
                          ? experienceForm.errors.location
                          : null}
                      </div>
                    </div>
                    <div className="mb-2 col-md-12">
                      <div
                        className=" d-flex align-items-center"
                        style={{
                          justifyContent: "space-between",
                        }}
                      >
                        <label className="form-label fw-bold fs-6">
                          Currently Working
                        </label>
                        <div className="flex justify-content-center">
                          <InputSwitch
                            name="currentlyWorkingHere"
                            checked={experienceForm.values.currentlyWorkingHere}
                            onChange={(e) => {
                              experienceForm.setFieldValue(
                                "currentlyWorkingHere",
                                e.value
                              );
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="mb-2 col">
                      <div className="cover-form">
                        <label className="form-label">
                          Start Date
                          <i className="inValidError">*</i>
                        </label>
                        <input
                          type="date"
                          name="startDate"
                          onClick={(e) =>
                            e.target.showPicker && e.target.showPicker()
                          }
                          className={
                            "form-control" +
                            (experienceForm.errors.startDate &&
                            experienceForm.touched.startDate
                              ? " is-invalid"
                              : "")
                          }
                          onChange={(event) => {
                            experienceForm.handleChange(event);
                          }}
                          value={experienceForm.values.startDate}
                          placeholder="Start Date"
                        />
                      </div>
                      <div className="invalid-feedback">
                        {experienceForm.errors.startDate &&
                        experienceForm.touched.startDate
                          ? experienceForm.errors.startDate
                          : null}
                      </div>
                    </div>
                    {!experienceForm.values.currentlyWorkingHere && (
                      <div className="mb-2 col">
                        <div className="cover-form">
                          <label className="form-label">
                            End Date <i className="inValidError">*</i>
                          </label>
                          <input
                            type="date"
                            name="endDate"
                            onClick={(e) =>
                              e.target.showPicker && e.target.showPicker()
                            }
                            className={
                              "form-control" +
                              (experienceForm.errors.endDate &&
                              experienceForm.touched.endDate
                                ? " is-invalid"
                                : "")
                            }
                            onChange={experienceForm.handleChange}
                            value={experienceForm.values.endDate}
                            placeholder="End Date"
                          />
                        </div>
                        <div className="invalid-feedback">
                          {experienceForm.errors.endDate &&
                          experienceForm.touched.endDate
                            ? experienceForm.errors.endDate
                            : null}
                        </div>
                      </div>
                    )}

                    <div className="col-md-12">
                      <div className="row">
                        <div className="mb-3 col-md-12">
                          <div className="cover-form">
                            <label className="form-label">Project Detail</label>
                            <Editor
                              name="projectDetails"
                              value={experienceForm.values.projectDetails}
                              onTextChange={(e) =>
                                experienceForm.setFieldValue(
                                  "projectDetails",
                                  e.htmlValue
                                )
                              }
                              headerTemplate={headerTemplate}
                              style={{ height: "320px" }}
                              onBlur={() =>
                                experienceForm.setFieldTouched(
                                  "projectDetails",
                                  true
                                )
                              }
                            />
                          </div>
                        </div>
                        <div className="mb-3 col-md-12">
                          <div className="cover-form">
                            <label className="form-label">
                              Responsibilities
                            </label>
                            <input
                              type="text"
                              name="responsibilities"
                              className="form-control"
                              onChange={experienceForm.handleChange}
                              value={experienceForm.values.responsibilities}
                              placeholder="Responsibilities"
                            />
                          </div>
                        </div>
                        <div className="mb-2 col-md-12">
                          <div className="cover-form">
                            <label className="form-label">Technology</label>
                            <input
                              type="text"
                              name="technology"
                              className={"form-control"}
                              onChange={experienceForm.handleChange}
                              value={experienceForm.values.technology}
                              placeholder="Technology"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>{" "}
                </div>

                <div className="col-md-12 mt-3">
                  <div className="btns-grp">
                    <Link to={`/Profile/${userDetails.GUID}`}>
                      <button
                        className="add-click"
                        style={{ width: "115px" }}
                        fdprocessedid="5mw059"
                      >
                        Cancel
                      </button>
                    </Link>
                    {GUID ? (
                      <button
                        type="submit"
                        className="savebutton"
                        fdprocessedid="jjj57m"
                        disabled={Isloading}
                      >
                        {Isloading ? "Please wait..." : "Update"}
                      </button>
                    ) : (
                      <button
                        type="submit"
                        className="savebutton"
                        fdprocessedid="jjj57m"
                        disabled={Isloading}
                      >
                        {Isloading ? "Please wait..." : "Save"}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        {Isloading ? (
          <Suspense>
            <ComponentLoader />
          </Suspense>
        ) : (
          ""
        )}
      </div>
    </>
  );
}

export default AddExperience;
